(function () {
  'use strict';

  var script = document.currentScript;
  var current = String(script && script.dataset.currentLanguage || document.documentElement.lang || '').toLowerCase().split('-')[0];
  var shopifyCountry = String(script && script.dataset.country || '').toUpperCase();
  var localizedRoot = String(script && script.dataset.localizedRoot || '/');
  var geoUrl = String(script && script.dataset.geoUrl || '').trim();
  // Veröffentlichte Sprachen setzt das Layout (data-supported-languages="de,en,fr"); ohne Attribut wie bisher nur de/en.
  var supported = String(script && script.dataset.supportedLanguages || '').toLowerCase().split(',').map(function (code) {
    return code.trim().split('-')[0];
  }).filter(function (code, index, all) { return /^[a-z]{2,3}$/.test(code) && all.indexOf(code) === index; });
  if (!supported.length) supported = ['de', 'en'];
  if (supported.indexOf(current) === -1) return;

  var preferenceKey = 'melodyglow-language-preference';
  var automaticKey = 'melodyglow-language-auto-v2';

  function storePreference(event) {
    var control = event.target.closest('[data-mg-language-option]');
    if (!control) return;
    try { window.localStorage.setItem(preferenceKey, String(control.value || '')); } catch (ignore) {}
  }

  function switchTo(desired) {
    if (supported.indexOf(desired) === -1 || desired === current) return;
    try {
      var automatic = JSON.parse(window.sessionStorage.getItem(automaticKey) || '{}');
      if (automatic.from === current && automatic.to === desired) return;
      window.sessionStorage.setItem(automaticKey, JSON.stringify({ from: current, to: desired }));
    } catch (ignore) {}

    var option = document.querySelector('[data-mg-language-option][value="' + desired + '"]');
    if (option && option.form) option.form.requestSubmit ? option.form.requestSubmit(option) : option.click();
  }

  document.addEventListener('click', storePreference);

  // Ein expliziter Sprachpfad (/en/…, /fr/… aus Anzeige, Mail oder Umschalter) gilt vor der gespeicherten Vorliebe;
  // sonst schickt eine alte Vorliebe „de“ jeden Besucher eines FR-Anzeigenlinks zurück auf Deutsch.
  var explicitLocalePath = localizedRoot !== '/' && new RegExp('^/' + current + '(?:/|$)', 'i').test(window.location.pathname);
  if (explicitLocalePath) return;

  var saved = '';
  try { saved = String(window.localStorage.getItem(preferenceKey) || ''); } catch (ignore) {}
  if (supported.indexOf(saved) !== -1) {
    switchTo(saved);
    return;
  }

  var browserLanguage = String((navigator.languages && navigator.languages[0]) || navigator.language || '').toLowerCase();
  if (['DE', 'AT'].indexOf(shopifyCountry) !== -1 || browserLanguage.indexOf('de') === 0) {
    switchTo('de');
    return;
  }

  // Browser in einer weiteren veröffentlichten Sprache (fr, fr-FR, fr-BE …) → diese Sprache. Englisch entscheidet wie bisher die Geo-Abfrage.
  var browserCode = browserLanguage.split(/[-_]/)[0];
  if (browserCode !== 'de' && browserCode !== 'en' && supported.indexOf(browserCode) !== -1) {
    switchTo(browserCode);
    return;
  }

  if (!/^https:\/\//i.test(geoUrl)) {
    switchTo('en');
    return;
  }

  fetch(geoUrl, { method: 'GET', mode: 'cors', credentials: 'omit', headers: { Accept: 'application/json' } })
    .then(function (response) { if (!response.ok) throw new Error('geo_failed'); return response.json(); })
    .then(function (result) {
      // Der Worker darf jede veröffentlichte Sprache vorschlagen (z. B. fr für FR/BE/LU/MC); alles andere → Englisch wie bisher.
      var suggested = result && typeof result.suggested_language === 'string' ? result.suggested_language : '';
      switchTo(suggested === 'de' || (suggested !== 'en' && supported.indexOf(suggested) !== -1) ? suggested : 'en');
    })
    .catch(function () { switchTo('en'); });
}());
